import React from "react";
import { TextField } from "@mui/material";

export default function Input(props) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    type = "text",
    variant = "outlined",
    sx = {}, // Add sx prop to accept custom styles
  } = props;
  return (
    <TextField
      variant={variant}
      label={label}
      name={name}
      value={value}
      type={type}
      onChange={onChange}
      sx={sx} // Pass the sx prop to TextField
      {...(error && { error: true, helperText: error })}
    />
  );
}